export default __webpack_public_path__ + "static/media/anne-francoise-lap.1f25e5b3.jpg";